import {Decoder} from './decoder';

/* tslint:disable:variable-name */

/** See `Decoder.string` */
export const string = Decoder.string;

/** See `Decoder.number` */
export const number = Decoder.number;

/** See `Decoder.boolean` */
export const boolean = Decoder.boolean;

/** See `Decoder.anyJson` */
export const anyJson = Decoder.anyJson;

/** See `Decoder.unknownJson` */
export const unknownJson: () => Decoder<unknown> = Decoder.unknownJson;

/** See `Decoder.constant` */
export const constant = Decoder.constant;

/** See `Decoder.object` */
export const object = Decoder.object;

/** See `Decoder.array` */
export const array = Decoder.array;

/** See `Decoder.tuple` */
export const tuple = Decoder.tuple;

/** See `Decoder.dict` */
export const dict = Decoder.dict;

/** See `Decoder.optional` */
export const optional = Decoder.optional;

/** See `Decoder.oneOf` */
export const oneOf = Decoder.oneOf;

/** See `Decoder.union` */
export const union = Decoder.union;

/** See `Decoder.intersection` */
export const intersection = Decoder.intersection;

/** See `Decoder.withDefault` */
export const withDefault = Decoder.withDefault;

/** See `Decoder.valueAt` */
export const valueAt = Decoder.valueAt;

/** See `Decoder.succeed` */
export const succeed = Decoder.succeed;

/** See `Decoder.fail` */
export const fail = Decoder.fail;

/** See `Decoder.lazy` */
export const lazy = Decoder.lazy;
